"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieStorage = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}
function mergeDeep(target) {
    var _a, _b;
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    if (!sources.length)
        return target;
    var source = sources.shift();
    if (isObject(target) && isObject(source)) {
        for (var key in source) {
            if (isObject(source[key])) {
                if (!target[key])
                    Object.assign(target, (_a = {}, _a[key] = {}, _a));
                mergeDeep(target[key], source[key]);
            }
            else {
                Object.assign(target, (_b = {}, _b[key] = source[key], _b));
            }
        }
    }
    return mergeDeep.apply(void 0, __spreadArray([target], sources, false));
}
var eachRecursive = function (obj, cb, parentKey) {
    if (parentKey === void 0) { parentKey = ""; }
    Object.keys(obj).forEach(function (key) {
        if (isObject(obj[key]))
            eachRecursive(obj[key], cb, [parentKey, key].join("|"));
        else
            cb([parentKey, key].join("|"), obj[key]);
    });
};
var getAllCookiesStartWith = function (startWithKey) {
    return document.cookie
        .split(";")
        .map(function (cv) { return cv.split("=").map(function (v) { return v.trim(); }); })
        .filter(function (_a) {
        var key = _a[0];
        return key !== startWithKey && key.startsWith(startWithKey);
    })
        .reduce(function (ac, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return Object.assign(ac, (_b = {}, _b[key] = value, _b));
    }, {});
};
var isArrayString = function (v) { return v.startsWith("[") && v.endsWith("]"); };
function setNestedKeys(keys, value) {
    var decodedValue = decodeURIComponent(value);
    if (keys.length === 0) {
        if (isArrayString(decodedValue)) {
            return JSON.parse(decodedValue);
        }
        else if (['true', 'false'].includes(decodedValue)) {
            return decodedValue !== 'false';
        }
        return decodedValue;
    }
    // Initialize an empty object
    var result = {};
    // Get the first key from the array
    var firstKey = keys[0], restKeys = keys.slice(1);
    // Recursively call setNestedKeys to build the nested structure
    result[firstKey] = setNestedKeys(restKeys, value);
    return result;
}
exports.cookieStorage = {
    getItem: function (key) {
        var keyCookies = getAllCookiesStartWith(key);
        var keyObject = {};
        Object.keys(keyCookies).forEach(function (startWithKey) {
            var keySegments = startWithKey.split("|");
            keyObject = mergeDeep(keyObject, setNestedKeys(keySegments, keyCookies[startWithKey]));
        });
        return JSON.stringify(keyObject[key]);
    },
    setItem: function (storeKey, value) {
        var days = 30;
        var expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        var jsonValue = JSON.parse(value);
        exports.cookieStorage.removeItem(storeKey);
        eachRecursive(jsonValue, function (key, value) {
            var _value = Array.isArray(value) ? JSON.stringify(value) : value;
            js_cookie_1.default.set("".concat(storeKey).concat(key), _value, {
                expires: expires,
                path: "/",
            });
        });
    },
    removeItem: function (key) {
        var keyCookies = getAllCookiesStartWith(key);
        Object.keys(keyCookies).forEach(function (k) {
            js_cookie_1.default.remove(k);
        });
    },
};
